import type { IconData } from '@stacksjs/iconify-core'

export const tabletF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5 17a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default tabletF
